"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
exports.DataLayerSSRContext = react_1.createContext({});
function useModifySSRContext(windowProperty, dataLayer) {
    var ssrContext = react_1.useContext(exports.DataLayerSSRContext);
    ssrContext.getScriptComponent = function () {
        return (react_1.default.createElement("script", { dangerouslySetInnerHTML: {
                __html: "window." + windowProperty + " = JSON.parse('" + JSON.stringify(dataLayer)
                    .replace(/'/g, "\\'")
                    .replace(/"/g, '\\"') + "');",
            }, key: "react-data-layer-script-" + windowProperty }));
    };
}
exports.useModifySSRContext = useModifySSRContext;
